/* services */
import BryService from '@/services/Assinaturas/BryService'

class BaseSignature {
  constructor () {
    this.certificados = []
    this.certificadoSelecionado = {}
  }

  async obterCertificados () {
    if (!BryService.isExtensionInstalled()) {
      this.displayError('', 'Certificados não instalados.')
    }
    this.certificados = await BryService.getCertificates()

    if (!this.certificados || !this.certificados.length) {
      return this.displayError('', 'Nenhum Certificado encontrado.')
    } else if (this.certificados.length > 1) {
      return this.certificados
    } else {
      this.certificadoSelecionado = this.certificados[0]
      // Anulando certificados obtidos
      this.certificados = null

      return this.certificadoSelecionado
    }
  }

  onSelectCertificado (certificado) {
    this.certificadoSelecionado = certificado
    // Anulando certificados obtidos
    this.certificados = null
    // Assinando documentos
    return this.certificadoSelecionado
  }

  displayError (title, text) {
    objSwal.error.title = title
    objSwal.error.text = text
    objSwal.error.html = ""

    return Swal.fire(objSwal.error).then(() => {
      objSwal.error.title = ''
      objSwal.error.text = ''
      objSwal.error.html = ''
    })
  }

  displaySuccess (title, text) {
    objSwal.success.title = title
    objSwal.success.text = text
    objSwal.success.html = ""

    return Swal.fire(objSwal.success).then(() => {
      objSwal.success.title = ''
      objSwal.success.text = ''
      objSwal.success.html = ''
    })
  }
}

export default BaseSignature
